/* eslint-disable prettier/prettier */
import axios from "axios";
import { DayMonthYearFormatOnly } from "../../helpers/momentFormat";

const state = {
  deliveries: {},
  delivery: {},
  isLoadingTable: false,
  showDeleteModal: false
};

const mutations = {
  getPaginatedData(state, payload) {
    state.isLoadingTable = true;
    axios
      .get(
        `api/deliveries/page=${payload.page}&pageSize=${payload.pageSize}/${
          payload.query
        }`
      )
      .then(response => {
        response.data.data.forEach(d => {
          d.deliveryDate = DayMonthYearFormatOnly(d.deliveryDate);
          if (d.siDate) d.siDate = DayMonthYearFormatOnly(d.siDate);
          if (d.drDate) d.drDate = DayMonthYearFormatOnly(d.drDate);
          d.clients = d.clients.join(",");
        });
        state.deliveries = response.data;
        // eslint-disable-next-line no-console
      })
      .catch(error => console.log(error))
      .then(() => (state.isLoadingTable = false));
  },
  openDeleteModal(state, payload) {
    state.showDeleteModal = payload.showDeleteModal;
    if (payload.delivery) {
      state.delivery = payload.delivery;
    } else {
      state.delivery = {};
    }
  }
};

const actions = {
  getPaginatedData({ commit }, payload) {
    commit("getPaginatedData", payload);
  },
  openDeleteModal({ commit }, payload) {
    commit("openDeleteModal", payload);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
